import * as Constants from './Constants'
import ElectronIPC from './ElectronIPC'
import { v4 as uuidv4 } from 'uuid'
import { setWithDefault } from '../utils'
import * as DetectBrowser from 'detect-browser'

export let env: { [key: string]: any } = {}

export async function load() {
    const _env = await ElectronIPC.getEnvironmentVariables()
    console.log(`Loaded environment variables.`)

    // we do not want to lose reference to the object so we copy each item over
    Object.keys(_env).forEach((key) => (env[key] = _env[key]))

    if (env.TEST_BROWSER_SESSIONS) {
        setBrowserSessionEnvironmentVariables()
    }

    return env
}

export function setBrowserSessionEnvironmentVariables() {
    env.IS_ELECTRON = false

    if (window.process) {
        Object.keys(process.env).forEach((key) => {
            env[key] = process.env[key]
        })
    } else if (import.meta.env) {
        Object.keys(import.meta.env).forEach((key) => {
            env[key] = import.meta.env[key]
        })
    }

    env.API_BASE_PATH = setWithDefault(localStorage.getItem('API_BASE_PATH'), import.meta.env.VITE_API_BASE_PATH)
    env.WSS_BASE_PATH = setWithDefault(localStorage.getItem('WSS_BASE_PATH'), import.meta.env.VITE_WSS_BASE_PATH)

    env.ANALYTICS_WRITE_KEY = setWithDefault(
        localStorage.getItem('ANALYTICS_WRITE_KEY'),
        import.meta.env.VITE_ANALYTICS_WRITE_KEY
    )
    env.APP_VERSION = import.meta.env.VITE_VERSION
    env.INSTANCE_ID = uuidv4()
    env.LOG_LEVEL = Number(setWithDefault(localStorage.getItem('LOG_LEVEL'), '400'))

    env.MUSE_RESOURCES_PATH = Constants.links.muse_static_resources_path
    env.MUSE_RESOURCES_PATH_PROTOCOL = 'https://'

    env.OS = 'darwin' // just choose a value
    const browserInfo = DetectBrowser.detect()
    if (browserInfo) {
        env.BROWSER_NAME = browserInfo.name
        env.BROWSER_VERSION = browserInfo.version
    }
}
